import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface EyebrowProps extends HTMLAttributes<HTMLDivElement> {
  onDark?: boolean;
}

export function Eyebrow({ onDark = false, className, children, ...rest }: EyebrowProps) {
  return (
    <div
      className={cn(
        'font-sans text-xs font-bold uppercase tracking-[0.14em]',
        onDark ? 'text-[var(--ollio-gold)]' : 'text-[var(--ollio-gold-deep)]',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
